module.exports = __webpack_public_path__ + "static/media/logout.6619998b.svg";